import { RoutedViewProps } from "@my-dld/utils/UrlUtils";
import React, { Component } from "react";
import EjariApi from "@eres/ejari-api";
import { getProjectsSearchQuery, getPropertiesRowSearchQuery } from "@eres/ejari-api/api";
import { hideLoading, showErrorMessage, showLoading } from "@my-dld/utils/UIUtils";
import { PropertiesWithProject, RentalStatus } from "@eres/ejari-api/Entity/LeasedProperties";
import Strings from "@my-dld/assets/strings";
import { navigateWithInParent } from "@my-dld/utils/StoreUtils";
import { LeasedContext, resetLeasedContext, updateLeasedContext } from "@eres/ejari-core/contexts/LeasedContext";
import { LeasedPropertySearch } from "@eres/ejari-api/IApi";
import ListGridDataView from "@my-dld/components/DataView/ListGridDataView";
import LeasedProjectSearch from "../../component/Leased/LeasedProjectSearch";
import ProjectListView from "../../component/Leased/ProjectListView";
import ProjectGridView from "../../component/Leased/ProjectGridView";
import { GetPropertiesWithProjectsResponse } from "@eres/ejari-api/EjariSecurityUtil";

interface Props extends RoutedViewProps {

}

interface State {
	isLoading: boolean;
	projects?: PropertiesWithProject[];
}

class PropertiesWithProjects extends Component<Props, State> {
	static contextType = LeasedContext;
	context!: React.ContextType<typeof LeasedContext>;

	constructor( props: Props ) {
		super( props );
		this.state = {
			isLoading: true,
		};
	}

	componentDidMount(): void {
		const { propertySearch, projects } = this.context;
		if ( projects ) {
			this.setState( {
				isLoading: false,
				projects: projects,
			} );
		} else {
			this.loadProjectProperties( propertySearch );
		}
	}

	render() {
		const { isLoading, projects } = this.state;
		return <ListGridDataView
			isLoading={ isLoading }
			dataAvailable={ projects && projects.length > 0 }
			title={ Strings.dash_ejari_properties_title }
			renderListView={ this.renderListView }
			renderGridView={ this.renderGridView }>
			<LeasedProjectSearch onSearch={ this.onSearch } onReset={ this.onReset }/>
		</ListGridDataView>;
	}

	private renderListView = () => {
		const { projects } = this.state;
		return <ProjectListView
			projects={ projects ? projects : [] }
			onProjectSelect={ this.onProjectSelect }/>;
	};

	private renderGridView = () => {
		const { projects } = this.state;
		return <ProjectGridView
			projects={ projects ? projects : [] }
			onProjectSelect={ this.onProjectSelect }/>;
	};

	private onSearch = ( propertySearch: LeasedPropertySearch ) => {
		showLoading();
		updateLeasedContext( { propertySearch: propertySearch } );
		this.loadProjectProperties( propertySearch );
	};

	private onReset = () => {
		showLoading();
		resetLeasedContext();
		this.loadProjectProperties();
	};

	private loadProjectProperties = ( propertySearch?: LeasedPropertySearch ) => {
		const searchQuery = "pageIndex=0&pageSize=50"; // getPropertiesRowSearchQuery( propertySearch );
		EjariApi.getPropertiesWithProjects( searchQuery ).then( ( resp: any ) => {
			hideLoading();
			this.handleResponse(resp.Response );
		} ).catch( e => {
			this.handleResponse( [] );
			hideLoading();
			showErrorMessage( e );
		} );
	};

	private handleResponse( projects: PropertiesWithProject[] ) {
		console.log("PROJECTS =====> ", projects);
		this.setState( {
			projects: projects,
			isLoading: false,
		} );
	}

	private onProjectSelect = ( project: PropertiesWithProject ) => {
		const { projects } = this.state;
		const propertySearch = this.context.propertySearch;
		const rentalStatus = ( propertySearch && propertySearch.PropertyStatus ) ?
			propertySearch.PropertyStatus : RentalStatus.ALL;
		updateLeasedContext( { projects: projects, project: project, properties: undefined } );
		navigateWithInParent( "mydld", `leased/properties/${ rentalStatus }` );
	};
}


export default PropertiesWithProjects;
